
import { CanActivate, CanActivateChild, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import  * as emiGlobals from 'app/globals';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/debounceTime';
import {Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import { Subject } from "rxjs/Subject";
import { BehaviorSubject } from 'rxjs';
import { HttpService } from "app/shared/services/http.service";
// import { HttpClient } from "../../../../node_modules_ex1/@angular/common/http";


@Injectable()
export class RealEstateService {


  prploanscheme: any;
  prpfacing: any;
  Lpercentage: any;
  propStage: any;
  propType: any;
  unitType: any;
  temp = new Array();
  themes: any;
  // private PropertyData = new Subject<JSON>();

  // showHomeLoanForm$ = this.ShowTheHlForm.asObservable();
  // // generate button click event
  // ShowHl(data: JSON) {
  //   this.ShowTheHlForm.next(data);
  // }



  private PropertyData = new BehaviorSubject('default message');
  currentValues = this.PropertyData.asObservable();


   private filterPropertyData = new BehaviorSubject('default');
   currentMessage = this.filterPropertyData.asObservable();


   getFilteredPropertyData(data: any) {
    console.log('observable-data111', data);
    this.filterPropertyData.next(data);
   }

  // Observable quote generation
  // PropertyDataSubscribe$ = this.PropertyData.asObservable();
  // generate offer event
  getPropertyData(data: any) {
    console.log('observable-data',data);
    this.PropertyData.next(data);
  }

  private onseearch_builder = emiGlobals.builderprojectnamelocalityonsearch; 
  private projectDetailsUrl = emiGlobals.builderProjectDetailsOnsearch;
  private postProject = emiGlobals.postProperty;

  private advanceSearch=emiGlobals.AdvancepropertySearch;

  private LoginUrl=emiGlobals.userLogin;
  private signup =emiGlobals.signup;
  private postProjectDetails=emiGlobals.PostPropertyDetails;
  private getuserprojetcts =emiGlobals.getUserProjects;
  private getprojectDetails=emiGlobals.propertyDetails;
  private deleteGImages=emiGlobals.DeleteGalleryImages;
  private defaultproperties=emiGlobals.DefaultPortalProperties;
  private portalUser=emiGlobals.userdetails;

  private LegaldocumentUploadUrl=emiGlobals.uploadlegalDocunment;
  private LeadUploadUrl = emiGlobals.uploadLeadUrl;

  private agentCreation=emiGlobals.PropertyAgentCreation;
  private GetProjectCostEmiSavingsOnId=emiGlobals.ProjectCostEmiSavings;
  private PropertyPaymentTerms=emiGlobals.PropertyPaymentTerms;
  

  projectType=new Array();
  ptype:any;
  projectUnit=new Array();
  constructor(
    private _http:Http,public httpService: HttpService,
    
  ) {
    this.doRequest();
   }
  private headers: Headers ;
  private options: RequestOptions ;item
  queryUrl: string = '?item=';
  parameter:any;

  private deActivateLinks = new Subject<JSON>();

  private ChangeActiveItem = new Subject<JSON>();

  ChangeActiveItem$=this.ChangeActiveItem.asObservable();
   
  ChangeActive(data){
    this.ChangeActiveItem.next(data)
  }

  // Observable show form on apply button click
  DeActivateLinks$ = this.deActivateLinks.asObservable();
  // generate button click event
  Deactivate(data: JSON) {
    this.deActivateLinks.next(data);
  }

  doRequest(){
    let token =  localStorage.getItem('id_token');
    // this.headers= new Headers( {
    //   'Content-Type': 'application/json',
    //   'Accept': 'application/json',
    //   'Access-Control-Allow-Headers': 'Content-Type',
    // }); 

    this.headers= new Headers( {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin':'*',
      'Access-Control-Allow-Headers': 'Content-Type',
    }); 
    this.headers= new Headers();
    this.headers.append('Authorization','Bearer '+token);
    this.options = new RequestOptions ({ headers: this.headers} );   
      
  }

  search(terms: Observable<any>) {
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => this.searchEntries(term));
  }
  searchEntries(term) {
    return this._http
        .get(this.onseearch_builder +this.queryUrl+ term,this.options)
        .map(res => res.json());
  }

  getProjectDetails(formValue,types,unit){
    this.doRequest();
    this.projectType.length=0;
    this.projectUnit.length=0;
    for(let i=0;i<types.length;i++){
      this.projectType.push(types[i].itemName);
      if(i==0){
        this.ptype = types[i].itemName ;
      } else {
        this.ptype = this.ptype + ',' +  types[i].itemName;
      }
      
    }
    for(let i=0;i<unit.length;i++){
      this.projectUnit.push(unit[i].itemName);
    }
    let stringType=this.projectType.toString();
    let stringUnit=this.projectUnit.toString();
    console.log(stringType);
    console.log(stringUnit);
    console.log(this.ptype);
    this.parameter='?mode='+formValue.buy+'&'+'city='+formValue.city+'&'+'project_name='+formValue.project_name+'&'+'min_price='+formValue.min_price+'&'+'max_price='+formValue.max_price+'&'+'unit_type='+stringUnit+'&'+'project_type='+stringType+'&'+'type='+formValue.form_type;
    return this._http.
       get(this.projectDetailsUrl+this.parameter,this.options)
       .map(res=>res.json());
  }
  PropertySearch(params){
    this.doRequest();
    if(params.UnitType){
      let propertyUnitType=params.UnitType.toString();
      this.unitType=propertyUnitType.replace(/\"/g, "");
      
    }
    if(params.PropertyType){
      let propertyType=params.PropertyType.toString();
      this.propType=propertyType.replace(/\"/g, "");
    }
    if(params.PropertyStage){
      let propertyStage=params.PropertyStage.toString();
      this.propStage=propertyStage.replace(/\"/g, "")
    }
    if(params.PropertyFacing){
      let pfacing=params.PropertyFacing.toString();
      this.prpfacing=pfacing.replace(/\"/g, "");

    }
    if(params.LoanPercentageAvailable){
      let loanpercentage=params.LoanPercentageAvailable.toString();
      this.Lpercentage=loanpercentage.replace(/\"/g, "");
    }
    if(params.PropertyLoanScheme){
      let ploanscheme=params.PropertyLoanScheme.toString();
      this.prploanscheme=ploanscheme.replace(/\"/g, "");
    }
    if(params.themes){
      let themes=params.themes.toString();
      this.themes  =themes.replace(/\"/g, "");
    }

   let SearchParameter='?city='+params.City+'&'+'locprjbuilder='+
   params.LocationProjectBuilder+'&'+'unittype='+this.unitType+
   '&'+'minprice='+params.MinPrice+'&'+'maxprice='+params.MaxPrice+
   '&'+'propertyType='+this.propType+'&'+'property_for='+params.PropertyFor+'&'+'propertyStage='+this.propStage+
   '&'+'propertyfacing='+this.prpfacing+'&pmay='+params.Pmay+
   '&taxsavings='+params.TaxSavings+'&nilpreemi='+params.NilPreEmi+'&HolidayScheme='+params.EmiHolidayScheme+
   '&EmiWaiver='+params.EmiWaiverScheme+'&loanPercentage='+this.Lpercentage+
   '&loan_scheme='+this.prploanscheme+'&payment_schedule='+params.PaymentSchedule+'&fixed_rentals='+params.FixedRentals+
   '&min_property_size='+params.MinPropertySize+'&max_property_size='+params.MaxProperetySize+
   '&minbasepricesqft='+params.MinBasePricePersqft+'&maxbasepricesqft='+params.MaxBasePricePersqft+
   '&mintotalpricesqft='+params.MinTotalPricePersqft+'&maxtotalpricesqft='+params.MaxTotalPricePersqft+
    '&min_down_payment='+params.minDownPayment+'&max_down_payment=' +params.maxDownPayment+
    '&min_payment_schedule='+params.minPaymentSchedule+'&max_payment_schedule='+params.maxPaymentSchedule+
    '&min_fixed_rental='+params.minFixedRentals+ '&max_fixed_rental='+params.maxFixedRentals+
    '&themes=' + params.themes; 


   return this._http.
   get(this.advanceSearch+SearchParameter,this.options)
   .map(res=>res.json());
  }
 

  getCityList(){
    if(localStorage.getItem('PortalCity')){
      return  JSON.parse(localStorage.getItem('PortalCity'));
    }else{
      return [];
    }
  }
  PostPropertyImages(f){
    return this._http.post(this.postProject,f,this.options)
    .map(response => response.json());
   
  }

  UserLogin(value){
   return this._http.get(this.LoginUrl+'?email='+value,this.options).
    map(res=>res.json())
  }

  UserSignUp(value){
    return this._http.post(this.signup,value,this.options)
    .map(response => response.json())
   
  }

  //post your property

  PostYourProperty(value){
   
    return this._http.post(this.postProjectDetails,value,this.options).
     map(response=>response.json());
  }

  GetUserProjectList(id){
   
    return this._http.get(this.getuserprojetcts+'?portal_user_id='+id,this.options).
     map(response=>response.json());
  }

  //get Individual property details

  GetProjectDetails(id){
   
    return this._http.get(this.getprojectDetails+'?id='+id,this.options).
    map(response=>response.json());
  }
  DeleteImages(ImageId){
    return this._http.post(this.deleteGImages,ImageId,this.options).
     map(response=>response.json());
  }

  DefaultPortalProperties(){
    this.doRequest();
    return this._http.get(this.defaultproperties,this.options).
     map(response=>response.json());
  }

  GetPortalUserDetails(id){
    this.doRequest();
     return this._http.get(this.portalUser+'?userId='+id,this.options).
       map(response=>response.json());
  }

  PostLegalDocument(f){
    return this._http.post(this.LegaldocumentUploadUrl,f,this.options)
    .map(response => response.json());
  }

 PostAgentProfile(value){
  return this._http.post(this.agentCreation,value,this.options).
  map(response=>response.json());
 }

 GetProjectCostEmiSavings(id){
   return this._http.get(this.GetProjectCostEmiSavingsOnId+'?project_id='+id,this.options).
   map(response=>response.json());
 }
 GetPropertyPaymentTerms(id){
   return this._http.get(this.PropertyPaymentTerms+'?property_id='+id,this.options).
   map(response=>response.json());
 }

 getRealEstateAwardsAndBLogs() {
  return this.httpService.getAll(emiGlobals.realEstateAwardsAndBlogsList).map(response =>
     response);
  }
  
submitTheLeadData(data){
  debugger
  return this._http.post(this.LeadUploadUrl, data,this.options)
  .map(response => response.json());
  }
  sample(data){
    debugger
    console.log(data);
  }
  
}


@Injectable()
export class CanActivateViaEmiCustomerTokenGuard implements  CanActivate {

  constructor(
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;
    if(route.queryParams){
      return true;
    }
    if(localStorage.getItem('customer_token')){
      return true;
    }else{
      this.router.navigate(['/real-estate/user/data'])
      return false;
    }
  }

  }



// WEBPACK FOOTER //
// ./src/app/Real-Estate-Page/services/real-estate.service.ts